import React from 'react';
import cn from 'classnames';

const ListHorizontal = ({
  title,
  content,
  className,
  colTitle,
  colContent,
  nopad,
}) => {
  const c = cn(
    className ? className : '',
    nopad ? '' : 'py-2 mb-2',
    'row  list-item m-0 align-items-center'
  );

  return (
    <div className={c}>
      <div className={cn(colTitle ? colTitle : 'col-4', 'p-0')}>{title}</div>
      <div className="col-1 text-center p-0">:</div>
      <div
        className={cn(
          colContent ? colContent : 'col-7 fw-semibold',
          'p-0 text-start title'
        )}
      >
        {content}
      </div>
    </div>
  );
};

export default ListHorizontal;
